import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export default class AuthenticationRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  login() {
    throw new Error('[AuthenticationRepository#login] must be implemented')
  }

  notifyResetPassword() {
    throw new Error('[AuthenticationRepository#notifyResetPassword] must be implemented')
  }

  getAuthenticationToken() {
    throw new Error('[AuthenticationRepository#getAuthenticationToken] must be implemented')
  }
}
